export const membershipId = (memberships, system) => String((memberships || []).find(item => String(item?.system).toLowerCase() === system)?.memberId || "").trim();
export const REPORTING_NAME_FIELDS = ["firstName", "middleNameOrInitial", "lastName", "suffix"];

export function accountDraft(person, attributes = {}) {
  // Older remember-entry saves stored IDs only in registrationDefaults. Keep
  // those available until the next profile save migrates them to memberships.
  const nraMemberId = membershipId(person.memberships, "nra") || String(person.registrationDefaults?.nraMemberId || "").trim();
  const nraCompetitorId = membershipId(person.memberships, "nra-competitor") || String(person.registrationDefaults?.bullseyeNraCompetitorId || "").trim();
  return {
    displayName: String(person.displayName || attributes.preferred_username || ""),
    nraMemberId: nraMemberId || (!nraCompetitorId ? String(attributes["custom:nraId"] || "") : ""),
    nraCompetitorId,
    ...Object.fromEntries(REPORTING_NAME_FIELDS.map(field => [field, String(person.registrationDefaults?.[field] || "")])),
  };
}

export function profileRegistrationDefaults(person, draft = accountDraft(person)) {
  return { ...person.registrationDefaults, displayName: draft.displayName.trim(), nraMemberId: draft.nraMemberId.trim(), bullseyeNraCompetitorId: draft.nraCompetitorId.trim(),
    ...Object.fromEntries(REPORTING_NAME_FIELDS.map(field => [field, String(draft[field] || "").trim()])) };
}

export function mergeNraMemberships(memberships, draft) {
  const values = { nra: draft.nraMemberId.trim(), "nra-competitor": draft.nraCompetitorId.trim() };
  const seen = new Set();
  const result = [];
  for (const item of memberships || []) {
    const system = String(item?.system || "").toLowerCase();
    if (!Object.prototype.hasOwnProperty.call(values, system)) { result.push(item); continue; }
    if (values[system] && !seen.has(system)) result.push({ ...item, memberId: values[system], ...(values[system] !== item.memberId ? { verified: false, updatedAt: undefined } : {}) });
    seen.add(system);
  }
  for (const system of Object.keys(values)) {
    if (values[system] && !seen.has(system)) result.push({ system, memberId: values[system], label: system === "nra" ? "NRA Member ID" : "NRA Competitor ID" });
  }
  return result;
}

// Account detours may return only to a registration route. Never navigate to an
// arbitrary URL supplied in a query string, or carry unrelated query parameters.
export function registrationReturnTo(value) {
  if (typeof value !== "string" || !/^\/matches\/(arc|bullseye)\/[^/?#\\]+\/register(?:\?|$)/.test(value) || /[\\\r\n]/.test(value)) return "";
  try {
    const url = new URL(value, "https://competition.invalid");
    if (url.origin !== "https://competition.invalid" || !/^\/matches\/(arc|bullseye)\/[^/]+\/register$/.test(url.pathname)) return "";
    const id = decodeURIComponent(url.pathname.split("/")[3]);
    if (/[\\/?#]/.test(id) || [".", ".."].includes(id)) return "";
    const squad = url.searchParams.get("squad");
    return url.pathname + (squad ? "?" + new URLSearchParams({ squad }) : "");
  } catch { return ""; }
}

export function competitionAccountPath(returnTo, focusNra = false) {
  const target = registrationReturnTo(returnTo);
  const params = new URLSearchParams();
  if (target) params.set("returnTo", target);
  if (focusNra) params.set("focus", "nra");
  return "/competition/account" + (params.toString() ? "?" + params : "");
}
